import React from 'react';
import PropTypes from 'prop-types';
import { HotTable } from '@handsontable/react';
import { map } from 'lodash';
import { rgba2hex, isTextLight, UI_COLOR_DEFAULT, UI_COLOR_WHITE, ui, uiA } from 'envy-ui';
import 'handsontable/dist/handsontable.full.min.css';
import ReactResizeDetector from 'react-resize-detector';

export default function paTable({ height = 200, config }) {
  const currentConfig = JSON.parse(config);
  const {
    gridData: [headers, ...data],
    colWidths: manualColumnResize,
  } = currentConfig;
  const columns = map(headers, (_, index) => ({
    data: `${index}.displayValue`,
  }));
  const colHeaders = map(headers, 'displayValue');
  const renderer = (instance, td, row, col, prop, value) => {
    if (value) {
      const { hasError, condition, color } = data[row][col];

      const newTd = td;

      if (hasError && value !== 'Total') {
        newTd.style.backgroundColor = '#ff4c42';
      }

      if (condition) {
        newTd.style.backgroundColor = color;
        newTd.style.color = isTextLight(rgba2hex(color)) ? UI_COLOR_WHITE : UI_COLOR_DEFAULT;
      }

      newTd.innerHTML = value;

      return newTd;
    }

    return td;
  };

  return (
    <ReactResizeDetector
      handleWidth
      handleHeight
      refreshMode="throttle"
      refreshRate={500}
      refreshOptions={{ trailing: true }}
      render={({ width }) => (
        <div {...ui(uiA`absolute w-100% h-100%`)}>
          <HotTable
            licenseKey="4a5b6-746d3-70193-74e30-5de3e"
            height={height}
            columns={columns}
            data={data}
            allowInsertColumn={false}
            allowRemoveColumn={false}
            colHeaders={colHeaders}
            manualColumnResize={manualColumnResize}
            colWidths={manualColumnResize}
            renderer={renderer}
            viewportColumnRenderingOffset={50}
            viewportRowRenderingOffset={100}
            width={width}
            readOnly
          />
        </div>
      )}
    />
  );
}

paTable.propTypes = {
  config: PropTypes.string.isRequired,
  height: PropTypes.number,
};
